if (!customElements.get('sunpura-technical-reference')) {
  customElements.define('sunpura-technical-reference', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.nav = this.querySelector('.sp-reference__filters');
      this.stage = this.querySelector('.sp-reference__groups');
      this.groups = [...this.querySelectorAll('[data-reference-group]')];
      this.buttons = [...this.querySelectorAll('[data-reference-filter]')];
      this.addEventListener('toggle', event => {
        if (event.target.matches?.('.sp-reference__installation') && !event.target.open) event.target.querySelector('video')?.pause();
      }, { ...options, capture: true });
      if (!this.nav || this.groups.length < 2) return;
      this.groups.forEach(group => {
        group.id ||= this.id + '-category-' + group.dataset.referenceGroup;
      });
      this.buttons.forEach(button => {
        const key = button.dataset.referenceFilter;
        button.setAttribute('aria-controls', this.groups.filter(group => key === 'all' || group.dataset.referenceGroup === key).map(group => group.id).join(' '));
      });
      this.nav.hidden = false;
      this.select(this.groups[0].dataset.referenceGroup, false);
      this.nav.addEventListener('click', event => {
        const button = event.target.closest('button[data-reference-filter]');
        if (button && this.nav.contains(button)) this.select(button.dataset.referenceFilter);
      }, options);
      this.nav.addEventListener('keydown', event => {
        const index = this.buttons.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.buttons.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + this.buttons.length - 1) % this.buttons.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.buttons.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.select(this.buttons[next].dataset.referenceFilter);
        this.buttons[next].focus({ preventScroll: true });
        this.buttons[next].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: this.reduced.matches ? 'instant' : 'smooth' });
      }, options);
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const group = event.target.closest?.('[data-reference-group]');
        this.select(group?.dataset.referenceGroup || 'all', false);
        const guide = event.target.closest?.('.sp-reference__installation');
        if (guide) guide.open = true;
      }, options);
      this.reduced.addEventListener('change', () => {
        if (this.reduced.matches) this.cancelTransition();
      }, options);
      this.observer = new ResizeObserver(() => this.moveIndicator());
      this.observer.observe(this.nav);
      this.buttons.forEach(button => this.observer.observe(button));
    }
    moveIndicator() {
      const button = this.buttons?.find(item => item.dataset.referenceFilter === this.active);
      if (!button || !this.nav) return;
      this.nav.style.setProperty('--sp-filter-y', button.offsetTop + 'px');
      this.nav.style.setProperty('--sp-filter-height', button.offsetHeight + 'px');
      this.nav.style.setProperty('--sp-filter-x', button.offsetLeft + 'px');
      this.nav.style.setProperty('--sp-filter-width', button.offsetWidth + 'px');
    }
    cancelTransition() {
      this.stage?.getAnimations().forEach(animation => animation.cancel());
      this.stage?.style.removeProperty('overflow');
    }
    select(key, animate = true) {
      if (!this.buttons.some(button => button.dataset.referenceFilter === key)) return;
      const previous = this.active;
      const before = this.stage.getBoundingClientRect().height;
      this.cancelTransition();
      this.active = key;
      this.buttons.forEach(button => {
        const active = button.dataset.referenceFilter === key;
        button.setAttribute('aria-pressed', String(active));
        button.tabIndex = active ? 0 : -1;
      });
      this.groups.forEach(group => { group.hidden = key !== 'all' && group.dataset.referenceGroup !== key; });
      this.moveIndicator();
      const selected = this.buttons.find(button => button.dataset.referenceFilter === key);
      if (animate && previous !== key) {
        this.querySelector('.sp-reference__status').textContent = selected.textContent.trim();
        if (!this.reduced.matches) {
          const after = this.stage.getBoundingClientRect().height;
          this.stage.style.overflow = 'hidden';
          const animation = this.stage.animate([
            { height: before + 'px', opacity: .5 },
            { height: after + 'px', opacity: 1 }
          ], { duration: 320, easing: 'cubic-bezier(.16,1,.3,1)' });
          animation.onfinish = () => this.stage.style.removeProperty('overflow');
        }
      }
    }
    cleanup() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.cancelTransition();
      this.querySelectorAll('video').forEach(video => video.pause());
      this.querySelectorAll('[data-reference-group]').forEach(group => { group.hidden = false; });
      this.querySelectorAll('[data-reference-filter]').forEach(button => {
        button.removeAttribute('tabindex');
        button.removeAttribute('aria-controls');
      });
      const nav = this.querySelector('.sp-reference__filters');
      if (nav) nav.hidden = true;
      this.active = undefined;
    }
    disconnectedCallback() {
      this.cleanup();
    }
  });
}
